import React from "react";
import styled from "styled-components";

import Input from "../atoms/Input";

interface IProps {
  items: IFormInputItem[];
  onChangeEachItem: (item: string, value: string) => void;
}

export interface IFormInputItem {
  type: string;
  key: string;
  value: string;
  placeholder: string;
  required?: boolean;
}

const FormInput: React.FC<IProps> = ({ items, onChangeEachItem }) => {
  return (
    <OutWrapper>
      {items.map(item => (
        <Item key={item.key}>
          <FormTextInput
            type={item.key}
            placeholder={item.placeholder}
            value={item.value}
            required={item.required}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChangeEachItem(item.key, e.target.value)
            }
          />
        </Item>
      ))}
    </OutWrapper>
  );
};

FormInput.defaultProps = {};

export default FormInput;

const OutWrapper = styled.div``;
const Item = styled.div`
  display: flex;
`;

const FormTextInput = styled(Input)`
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ddd;
  margin-bottom: 26px;
  padding: 15px;
  font-size: 14px;
`;
